/**
 * SubscriptionCancelScreen
 * Shown when user cancels Stripe checkout
 */

import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  Platform,
} from 'react-native';
import { useNavigation } from '@react-navigation/native';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import Button from '../components/common/Button';
import { colors } from '../theme/colors';
import { typography } from '../theme/typography';
import { spacing } from '../theme/spacing';

export default function SubscriptionCancelScreen() {
  const navigation = useNavigation();

  const handleRetry = () => {
    // Go back to dashboard where they can try again
    navigation.reset({
      index: 0,
      routes: [{ name: 'MainContent' as never }],
    });
  };

  const handleGoHome = () => {
    navigation.reset({
      index: 0,
      routes: [{ name: 'MainContent' as never }],
    });
  };

  return (
    <View style={styles.container}>
      {/* Icon */}
      <View style={styles.iconContainer}>
        <View style={styles.iconCircle}>
          <Icon name="close" size={48} color="#FFFFFF" />
        </View>
      </View>

      {/* Message */}
      <View style={styles.content}>
        <Text style={styles.title}>Paiement annulé</Text>
        <Text style={styles.subtitle}>
          Tu as annulé le paiement. Pas d'inquiétude, tu peux réessayer quand tu veux !
        </Text>
      </View>

      {/* Benefits reminder */}
      <View style={styles.reminderCard}>
        <Icon name="gift-outline" size={24} color={colors.primary} />
        <Text style={styles.reminderText}>
          Avec Premium, tu débloques les messages illimités, la détection d'arbitrage et le simulateur d'investissement.
        </Text>
      </View>

      {/* CTA */}
      <View style={styles.ctaContainer}>
        <Button
          title="Réessayer"
          onPress={handleRetry}
          style={styles.primaryButton}
        />
        <Button
          title="Retour à l'accueil"
          onPress={handleGoHome}
          variant="text"
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.background,
    paddingHorizontal: spacing.lg,
    paddingTop: Platform.OS === 'ios' ? 100 : 60,
    alignItems: 'center',
  },
  iconContainer: {
    marginBottom: spacing.xl,
  },
  iconCircle: {
    width: 100,
    height: 100,
    borderRadius: 50,
    backgroundColor: colors.textSecondary,
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    alignItems: 'center',
    marginBottom: spacing.xl,
  },
  title: {
    fontSize: typography.fontSize.xxl,
    fontWeight: typography.fontWeight.bold,
    color: colors.text,
    textAlign: 'center',
    marginBottom: spacing.sm,
  },
  subtitle: {
    fontSize: typography.fontSize.md,
    color: colors.textSecondary,
    textAlign: 'center',
    lineHeight: 24,
    maxWidth: 300,
  },
  reminderCard: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: `${colors.primary}10`,
    borderRadius: 12,
    padding: spacing.md,
    marginBottom: spacing.xl,
    maxWidth: 400,
  },
  reminderText: {
    flex: 1,
    fontSize: typography.fontSize.sm,
    color: colors.text,
    marginLeft: spacing.md,
    lineHeight: 20,
  },
  ctaContainer: {
    width: '100%',
    maxWidth: 300,
  },
  primaryButton: {
    marginBottom: spacing.sm,
  },
});
